/**
 * DataTable — renders a simple data table.
 *
 * data: {
 *   headers: ["Colonne 1", "Colonne 2", "Colonne 3"],
 *   rows: [
 *     ["valeur 1", "valeur 2", "valeur 3"],
 *     ["valeur 4", "valeur 5", "valeur 6"]
 *   ],
 *   caption: "Titre optionnel du tableau"
 * }
 */

export default function DataTable({ data }) {
    const headers = data?.headers;
    const rows = data?.rows;
    if (!Array.isArray(rows) || rows.length === 0) return null;

    return (
        <div className="qv-datatable-wrap">
            {data.caption && <div className="qv-datatable__caption">{data.caption}</div>}
            <table className="qv-datatable">
                {Array.isArray(headers) && headers.length > 0 && (
                    <thead>
                        <tr>
                            {headers.map((h, i) => (
                                <th key={i} className="qv-datatable__header">{h}</th>
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody>
                    {rows.map((row, ri) => (
                        <tr key={ri}>
                            {(Array.isArray(row) ? row : []).map((cell, ci) => (
                                <td key={ci} className={`qv-datatable__cell ${ci === 0 ? 'qv-datatable__cell--first' : ''}`}
                                    dangerouslySetInnerHTML={{ __html: cell }} />
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
